export const ECOM_PLATFORM_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd';
export const PageMap = {
  THANK_YOU_PAGE: 'thank_you_page',
  CHECKOUT: 'checkout'
};
export const RESULT_PROP_NAME = 'expressCheckoutButtonsResult';
export const FQDN = 'wix.ecom.*.checkout';
export const FORMS_TEMPLATE_IDS = {
  CUSTOMER_DETAILS_WO_ADDITIONAL_INFO: '3f63d41e-9b8e-4631-bfe0-e984965ad618'
};
export let FormFieldTarget = /*#__PURE__*/function (FormFieldTarget) {
  FormFieldTarget["additional_info_1"] = "additional_info_1";
  return FormFieldTarget;
}({});
export let FastFlowRedirectionReason = /*#__PURE__*/function (FastFlowRedirectionReason) {
  FastFlowRedirectionReason["hasTermsAndConditions"] = "hasTermsAndConditions";
  FastFlowRedirectionReason["shouldChooseShippingMethod"] = "shouldChooseShippingMethod";
  FastFlowRedirectionReason["hasCustomField"] = "hasCustomField";
  FastFlowRedirectionReason["hasViolations"] = "hasViolations";
  FastFlowRedirectionReason["hasTotalAmountMismatchWithLatestSeen"] = "hasTotalAmountMismatch";
  FastFlowRedirectionReason["hasTaxZipCodeError"] = "hasTaxZipCodeError";
  FastFlowRedirectionReason["hasTaxSubdivisionError"] = "hasTaxSubdivisionError";
  FastFlowRedirectionReason["hasShippingZipCodeError"] = "hasShippingZipCodeError";
  FastFlowRedirectionReason["hasShippingSubdivisionError"] = "hasShippingSubdivisionError";
  FastFlowRedirectionReason["hasLineItemPolicies"] = "hasLineItemPolicies";
  FastFlowRedirectionReason["hasMemberOnlyCheckout"] = "hasMemberOnlyCheckout";
  /**
   * @deprecated
   */
  FastFlowRedirectionReason["unknown"] = "unknown";
  return FastFlowRedirectionReason;
}({});
//# sourceMappingURL=consts.js.map